module.exports = __webpack_public_path__ + "img/button-large.533d25f6.svg";